// current-dates build: small, but names() still lists every zone
import momentTz from 'moment-timezone/builds/moment-timezone-with-data-10-year-range';

// Same option lists as the app's senior profile screen (utils/constants/mockData.ts).
export interface IOption {
  value: string;
  labelKey: string;
}

export const TEXT_LANGUAGE_OPTIONS: IOption[] = [
  ['en-US', 'english'],
  ['zh-CN', 'chineseSimplified'],
  ['zh-TW', 'chineseTraditional'],
  ['fr-FR', 'french'],
  ['es-ES', 'spanish'],
  ['de-DE', 'german'],
  ['ja-JP', 'japanese'],
  ['ko-KR', 'korean'],
  ['it-IT', 'italian'],
  ['ms-MY', 'malay'],
  ['in-ID', 'indonesian'],
  ['th-TH', 'thai'],
  ['pt-BR', 'portugueseBrazil'],
  ['pt-PT', 'portuguesePortugal'],
  ['ru-RU', 'russian'],
  ['vi-VN', 'vietnamese'],
].map(([value, key]) => ({ value, labelKey: `pages.setup.options.language.${key}` }));

// Voice differs from text: Mandarin / Cantonese instead of Simplified / Traditional Chinese.
export const VOICE_LANGUAGE_OPTIONS: IOption[] = [
  ['en-US', 'english'],
  ['zh-CN', 'mandarin'],
  ['zh-HK', 'cantonese'],
  ['fr-FR', 'french'],
  ['es-ES', 'spanish'],
  ['de-DE', 'german'],
  ['ja-JP', 'japanese'],
  ['ko-KR', 'korean'],
  ['it-IT', 'italian'],
  ['ms-MY', 'malay'],
  ['in-ID', 'indonesian'],
  ['th-TH', 'thai'],
  ['pt-BR', 'portugueseBrazil'],
  ['pt-PT', 'portuguesePortugal'],
  ['ru-RU', 'russian'],
  ['vi-VN', 'vietnamese'],
].map(([value, key]) => ({ value, labelKey: `pages.setup.options.language.${key}` }));

// "Go Home" navigation language is picked by country.
export const NAVIGATION_LANGUAGE_OPTIONS: IOption[] = [
  ['en-US', 'unitedStates'],
  ['zh-CN', 'china'],
  ['fr-FR', 'france'],
  ['es-ES', 'spain'],
  ['de-DE', 'germany'],
  ['ja-JP', 'japan'],
  ['ko-KR', 'southKorea'],
  ['it-IT', 'italy'],
  ['pt-PT', 'portugal'],
  ['ru-RU', 'russia'],
].map(([value, key]) => ({ value, labelKey: `pages.setup.options.country.${key}` }));

export const COGNITIVE_DECLINE_OPTIONS: IOption[] = ['1', '2', '3'].map((value) => ({
  value,
  labelKey: `pages.setup.options.cognitive.level${value}`,
}));

// Only canonical IANA areas (no legacy "US/Pacific" style aliases) - same rule as the app.
const TIMEZONE_AREAS = ['Africa', 'America', 'Antarctica', 'Arctic', 'Asia', 'Atlantic', 'Australia', 'Europe', 'Indian', 'Pacific'];

// moment-timezone's list, as in the app. (Intl.supportedValuesOf only returns ICU's canonical names -
// e.g. Asia/Saigon but not Asia/Ho_Chi_Minh or Asia/Vientiane - so searching it misses zones the app offers.)
export const getTimezoneOptions = (current?: string) => {
  const zones = momentTz.tz.names().filter((zone) => TIMEZONE_AREAS.includes(zone.split('/')[0]));
  if (current && !zones.includes(current)) zones.push(current);
  return zones.map((zone) => ({
    value: zone,
    label: `${zone.replace(/_/g, ' ')} (${momentTz.tz(zone).format('z')})`,
  }));
};
